import { createIcon } from "@chakra-ui/react";

const RestoreIcon = createIcon({
  displayName: "RestoreIcon",
  viewBox: "0 0 24 24",
  path: (
    <>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.4697 2.46973L14.5303 3.53039L11.0607 7.00006L14.5303 10.4697L13.4697 11.5304L8.93934 7.00006L13.4697 2.46973Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 13.0001C5 16.8661 8.13401 20.0001 12 20.0001C15.866 20.0001 19 16.8661 19 13.0001C19 9.13406 15.866 6.00006 12 6.00006C11.6605 6.00006 11.3266 6.02423 11 6.07095V7.59074C11.3243 7.53118 11.6585 7.50006 12 7.50006C15.0376 7.50006 17.5 9.96249 17.5 13.0001C17.5 16.0376 15.0376 18.5001 12 18.5001C8.96243 18.5001 6.5 16.0376 6.5 13.0001H5Z"
        fill="currentColor"
      />
    </>
  ),
});

export default RestoreIcon;
